import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import {ThemeLogo} from "../../theme";
import {useOfficeTranslation} from "../../i18n/OfficeTranslation";


const Header = (props) => {
  const [lightMode, setLightMode] = useState(window.localStorage.getItem("lightMode") === "true");
  const {t} = useOfficeTranslation();

  useEffect(() => {
    document.body.setAttribute("data-layout-mode", window.localStorage.getItem("lightMode") === "true" ? "light": "dark");
    document.body.setAttribute("data-topbar", window.localStorage.getItem("lightMode") === "true"  ? "light": "dark");
  }, [lightMode])

  function tToggle() {
    /*
      set logic for changing sidebar
    */
    if (document.body.clientWidth >= 993) {
      //desktop view
      if (props.leftSideBarType === "default") {
        props.changeSidebarType("small");
      } else if (
        props.leftSideBarType === "small" ||
        props.leftSideBarType === "compact"
      ) {
        props.changeSidebarType("default");
      }
    } else {
      //mobile view
      document.body.classList.toggle("sidebar-enable");
      //TODO: Repare this function for mobile use
      //props.changeSidebarType("default");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <ThemeLogo variant="smallDark" height="22" />
                </span>
                <span className="logo-lg">
                  <ThemeLogo variant="headerDark" height="48" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <ThemeLogo variant="smallLight" height="22" />
                </span>
                <span className="logo-lg">
                  <ThemeLogo variant="headerLight" height="48" />
                </span>
              </Link>
            </div>
            <button
              aria-label={t("common.sidebarContent.menu")}
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn font-size-16 header-item header-action-button"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>
          <div className="d-flex header-actions">
            <button
              aria-label={t(lightMode ? "common.theme.darkMode" : "common.theme.lightMode")}
              className="btn header-item header-action-button theme-mode-button"
              onClick={() => {
                window.localStorage.setItem("lightMode", !lightMode)
                setLightMode(!lightMode)
              }}
              type="button"
            >
              <i aria-hidden="true" className={`mdi ${lightMode ? "mdi-weather-night" : "mdi-white-balance-sunny"}`} />
            </button>
            <LanguageDropdown />
            <ProfileMenu />

            <div
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
              className="dropdown d-inline-block"
            ></div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};


export default Header;
